// extracted by mini-css-extract-plugin
module.exports = {"tagItems":"FaqTagList_tagItems__OmMxv","item":"FaqTagList_item__DQjqH"};